// Centralized timezone configuration
// Currently IST only, but designed for future multi-timezone support
// To add multi-timezone support in future:
// 1. Add timezone field to company_settings
// 2. Update getAppTimezone() to fetch from company settings
// 3. Add user preference override option

const TIMEZONE_CONFIG = {
  // Default timezone for the application
  defaultTimezone: 'Asia/Kolkata',

  // Display format preferences
  dateFormat: 'DD/MM/YYYY',  // Indian standard
  timeFormat: '12h',         // 12-hour with AM/PM

  // Locale for formatting
  locale: 'en-IN',

  // Supported timezones (for future use)
  supportedTimezones: [
    { id: 'Asia/Kolkata', label: 'India Standard Time (IST)', offset: '+05:30' },
    { id: 'America/New_York', label: 'Eastern Time (ET)', offset: '-05:00' },
    { id: 'America/Los_Angeles', label: 'Pacific Time (PT)', offset: '-08:00' },
    { id: 'Europe/London', label: 'Greenwich Mean Time (GMT)', offset: '+00:00' },
    { id: 'Europe/Paris', label: 'Central European Time (CET)', offset: '+01:00' },
    { id: 'Asia/Singapore', label: 'Singapore Time (SGT)', offset: '+08:00' },
    { id: 'Asia/Dubai', label: 'Gulf Standard Time (GST)', offset: '+04:00' },
    { id: 'Australia/Sydney', label: 'Australian Eastern Time (AET)', offset: '+10:00' }
  ]
};

/**
 * Get the application's current timezone
 * Future: Could fetch from user settings or company settings
 * @returns {string} IANA timezone identifier
 */
export const getAppTimezone = () => TIMEZONE_CONFIG.defaultTimezone;

/**
 * Get the application's locale for formatting
 * @returns {string} Locale string (e.g., 'en-IN')
 */
export const getAppLocale = () => TIMEZONE_CONFIG.locale;

/**
 * Get the preferred time format
 * @returns {string} '12h' or '24h'
 */
export const getTimeFormat = () => TIMEZONE_CONFIG.timeFormat;

/**
 * Get the preferred date format
 * @returns {string} Date format string (e.g., 'DD/MM/YYYY')
 */
export const getDateFormat = () => TIMEZONE_CONFIG.dateFormat;

/**
 * Get list of supported timezones
 * @returns {Array} Array of timezone objects with id, label, and offset
 */
export const getSupportedTimezones = () => TIMEZONE_CONFIG.supportedTimezones;

export default TIMEZONE_CONFIG;
